module.exports = __webpack_public_path__ + "img/mobile-hit-a-wall.0a3d7ba3.png";